import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/internal/operators/map";
import { ApiReportConstants } from "../../constants/api-constants/api-report.constants";
import { ApiPropertyValuationValuationRollConstants } from "../../constants/api-constants/api-property-valuation-valuation-roll.constants";
import { ApiPropertyValuationprojectCycleConstants } from "../../constants/api-constants/api-property-valuation-project-cycle.constants";
import { SharedConstants } from "../../constants/shared.constants";
let ReportService = class ReportService {
    http;
    selectedReportEventEmiter = new EventEmitter();
    submitFormEvent = new EventEmitter();
    constructor(http) {
        this.http = http;
    }
    getReportGroup(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and groupName ne '${SharedConstants.SYSTEM_REPORT_TYPE_GROUP}'`,
        };
        return this.http.get(ApiReportConstants.URL, {
            params,
        });
    }
    getReportGroupsByGroup(moduleId, groupName) {
        const params = {
            $filter: `moduleId eq ${moduleId} and groupName eq '${groupName}'`,
        };
        return this.http.get(ApiReportConstants.URL, {
            params,
        });
    }
    getReportGroupByGroupAndReportName(moduleId, reportName) {
        const params = {
            $filter: `moduleId eq ${moduleId}  and  name eq '${reportName}' and groupName ne '${SharedConstants.SYSTEM_REPORT_TYPE_GROUP}'`,
        };
        return this.http.get(ApiReportConstants.URL, {
            params,
        });
    }
    generateReport(model) {
        const headers = new HttpHeaders({
            "Content-Type": "application/json",
            Accept: "application/json",
        });
        return this.http.post(`${ApiReportConstants.URL}/${ApiReportConstants.FUNCTION_GENERATE_REPORT}`, model, { headers, responseType: "blob",
        });
    }
    selectedReportEvent(reportId, groupName, reports) {
        this.selectedReportEventEmiter.emit({ reportId, groupName, reports });
    }
    getSelectedReportEvent() {
        return this.selectedReportEventEmiter;
    }
    submitFormTriger(submit) {
        this.submitFormEvent.emit(submit);
    }
    submitFormListner() {
        return this.submitFormEvent;
    }
    getModuleValuationRolls(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId}`,
            $expand: `projectCycle`
        };
        return this.http.get(ApiPropertyValuationValuationRollConstants.URL, {
            params,
        }).pipe(map(x => {
            return x.value;
        }));
    }
    pvProjectCycle(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId}`
        };
        return this.http.get(ApiPropertyValuationprojectCycleConstants.URL, {
            params,
        }).pipe(map(x => {
            return x.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
ReportService = __decorate([
    Injectable({
        providedIn: "root",
    })
], ReportService);
export { ReportService };
